<template>
  <el-collapse-item :name="phaseData.index">
    <!-- 标题栏 -->
    <div slot="title">
      <i class="el-icon-s-operation"></i>
      阶段{{ phaseData.index }}：
      {{ phaseData.name || '未命名' }}
      <slot name="reorder" />
      <slot v-if="removable" name="remove" />
      <div
        v-else
        style="
          display: inline-block;
          font-size: 13px;
          font-weight: normal;
          color: #909090;
        "
      >
        <span v-if="phaseData.badge === 'harvest'">
          （采摘阶段，可编辑可重排序，不可删除）
        </span>
        <span v-if="phaseData.badge === 'plant'">
          （栽种定植阶段，可编辑可重排序，不可删除）
        </span>
      </div>
    </div>
    <!-- 阶段主体内容 -->
    <el-form
      :model="phaseData"
      size="mini"
      :rules="rules"
      style="padding: 15px 10px 0 10px"
    >
      <el-row :gutter="20">
        <!-- 左半部分：基本信息和环境控制 -->
        <el-col :span="14">
          <!-- 基本信息 -->
          <el-row :gutter="5">
            <el-col :span="8">
              <el-form-item prop="name">
                <el-input v-model="phaseData.name" placeholder="阶段的名称" />
              </el-form-item>
              <el-form-item prop="dutation" style="margin-top: 8px">
                阶段持续
                <el-input-number v-model="phaseData.dutation" :min="1" />
                天
              </el-form-item>
              <p>
                <span>自动环境控制：</span>
                <el-switch
                  v-model="phaseData.switchValue"
                  active-color="#ff4949"
                  inactive-color="#13ce66"
                  active-text="不需要"
                  inactive-text="需要"
                >
                </el-switch>
              </p>
            </el-col>
            <el-col :span="16">
              <el-form-item prop="memo">
                <el-input
                  v-model="phaseData.memo"
                  type="textarea"
                  :rows="5"
                  placeholder="该阶段的总体指导和建议等"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 环境参数 -->
          <el-card shadow="never" style="min-height: 266px">
            <el-row
              :gutter="10"
              v-show="!phaseData.switchValue"
              style="padding-left: 20px"
            >
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    :max="50"
                    :min="-10"
                    v-model="phaseData.environs.airt"
                    range
                    vertical
                    height="200px"
                    :marks="marks.airt"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">空气温度 ℃</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    :max="100"
                    :min="0"
                    v-model="phaseData.environs.airh"
                    range
                    vertical
                    height="200px"
                    :marks="marks.airh"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">空气湿度 %RH</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    :max="20"
                    :min="0"
                    v-model="phaseData.environs.illu"
                    range
                    vertical
                    height="200px"
                    :marks="marks.illu"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">光照强度 x1000 Lux</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    v-model="phaseData.environs.co2"
                    range
                    :max="2000"
                    :min="0"
                    vertical
                    height="200px"
                    :marks="marks.co2"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">二氧化碳浓度 ppm</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    :max="50"
                    :min="-10"
                    v-model="phaseData.environs.soilt"
                    range
                    vertical
                    height="200px"
                    :marks="marks.soilt"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">土壤温度 ℃</span>
                </el-form-item>
              </el-col>
              <el-col :span="3"
                ><el-form-item>
                  <el-slider
                    :max="100"
                    :min="0"
                    v-model="phaseData.environs.soilh"
                    range
                    vertical
                    height="200px"
                    :marks="marks.soilh"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">土壤湿度 %RH</span>
                </el-form-item></el-col
              >
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    :max="1000"
                    :min="0"
                    v-model="phaseData.environs.adh"
                    range
                    vertical
                    height="200px"
                    :marks="marks.adh"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">积温</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-slider
                    :max="6000"
                    :min="0"
                    v-model="phaseData.environs.par"
                    :step="100"
                    range
                    vertical
                    height="200px"
                    :marks="marks.par"
                    :disabled="phaseData.switchValue"
                    style="z-index: 0"
                  >
                  </el-slider>
                  <span class="vertical-text">光合辐照</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <!-- 右半部分：阶段的建议和备忘 -->
        <el-col :span="10">
          <el-table :data="phaseData.suggest">
            <el-table-column prop="stageDay" label="" width="60px">
              <template slot-scope="scope">
                第{{ scope.row.stageDay }}天
              </template>
            </el-table-column>
            <el-table-column prop="suggest" label="建议和备忘">
            </el-table-column>
            <el-table-column label="操作" width="40px">
              <template slot="header">
                <!-- 标题上显示一个新增启动按钮 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="新增"
                  placement="top"
                >
                  <el-button
                    icon="el-icon-plus"
                    type="primary"
                    circle
                    size="large"
                    style="padding: 4px"
                    @click="appoint(phaseData, phaseData.suggest, 'add')"
                  />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-button
                  icon="el-icon-edit"
                  type="warning"
                  circle
                  size="large"
                  style="padding: 4px"
                  @click="appointEditor(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            title="填加一条建议和备忘"
            :visible.sync="dialogFormVisible"
          >
            <!-- :rules="rules" -->
            <el-form
              size="small"
              :model="appointForm"
              ref="appointForm"
              style="margin: 0px auto"
              :rules="rules"
            >
              <el-form-item label="" prop="num">
                本阶段第
                <el-input-number
                  v-model="appointForm.num"
                  :min="minDay"
                  :max="maxDay"
                />
                天
              </el-form-item>
              <el-form-item label="内容" prop="suggest">
                <el-input
                  v-model="appointForm.suggest"
                  autocomplete="off"
                  type="textarea"
                  :rows="5"
                  size="mini"
                ></el-input>
              </el-form-item>
              <div style="margin-top: 15px">
                <el-button @click="cancel('appointForm')">取 消</el-button>
                <el-button type="primary" @click="sure('appointForm')"
                  >确 定</el-button
                >
              </div>
            </el-form>
          </el-dialog>
        </el-col>
      </el-row>
    </el-form>
  </el-collapse-item>
</template>
<script>
import marks from './scheme-slider-marks.js'
export default {
  name: 'SchemeDetailPhase',
  props: {
    'phase-data': {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      minDay: 1,
      maxDay: 1,
      marks: marks,
      dialogFormVisible: false,
      appointForm: {
        num: undefined,
        suggest: undefined,
        inputs: undefined,
      },
      stageIndex: '',
      contentIndex: undefined,
      rules: {
        name: [
          { required: true, message: '方案名称不能为空', trigger: 'blur' },
        ],
        dutation: [
          { required: true, message: '阶段天数不能为空', trigger: 'blur' },
        ],
        suggest: [
          {
            required: true,
            message: '当前建议或备忘不能为空',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    removable() {
      return !['plant', 'harvest'].includes(this.phaseData.badge)
    },
  },
  methods: {
    // 打开弹窗-新增建议和备忘
    appoint(obj, suggest, operate) {
      //  this.stageIndex = parseInt(obj.stage) - 1
      this.dialogFormVisible = true
      this.maxDay = 0
      this.minDay = 1
      for (let i = 1; i <= obj.dutation; i++) {
        if (obj.dutation == 1) {
          this.minDay = 1
        } else if (obj.dutation - i > 0) {
          this.minDay = 1
        }
        this.maxDay = parseInt(obj.dutation)
      }
      this.appointForm.num = this.minDay
    },
    // 打开弹窗-编辑建议和备忘
    appointEditor(row, index) {
      console.log(row)
      this.contentInd = index
      this.stageInd = index
      this.appointForm.num = row.stageDay
      this.appointForm.suggest = row.suggest
      this.appointForm.suggest = row.suggest
      this.maxDay = row.stageDay
      this.minDay = row.stageDay
      this.dialogFormVisible = true
    },
    // 弹窗-确定按钮
    sure(form) {
      console.log(form)
      this.$refs[form].validate((val) => {
        if (val) {
          let option = {}
          option.stageDay = this.appointForm.num
          option.suggest = this.appointForm.suggest
          option.inputs = this.appointForm.inputs
          option.suggest = this.appointForm.suggest
          if (!this.contentInd && this.contentInd != 0) {
            this.phaseData.suggest.push(option)
          } else if (this.contentInd || this.contentInd == 0) {
            this.phaseData.suggest[
              this.contentInd
            ].stageDay = this.appointForm.num
            this.phaseData.suggest[
              this.contentInd
            ].suggest = this.appointForm.suggest
            this.phaseData.suggest[
              this.contentInd
            ].suggest = this.appointForm.suggest
          }
          this.contentInd = undefined
          this.cancel()
        }
      })
    },
    // 弹窗-取消按钮
    cancel(appointForm) {
      this.appointForm.num = ''
      this.appointForm.suggest = ''
      this.appointForm.suggest = ''
      this.$refs['appointForm'].resetFields()
      this.dialogFormVisible = false
    },
  },
}
</script>

<style scoped>
/* 文字垂直 */
.vertical-text {
  position: relative;
  bottom: 170px;
  right: 28px;
  -webkit-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
}
.el-col-3 {
  height: 225px;
  width: 12.5%;
}
.el-form-item {
  margin: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/plant/programme/SchemeDetailPhase.vue